import LockRoundedIcon from "@mui/icons-material/LockRounded";
import { Notice, NoticeBody, NoticeTitle, NoticeTitleIcon } from "../styles";

export default function NoticeSection() {
  return (
    <Notice>
      <NoticeTitle>
        <NoticeTitleIcon>
          <LockRoundedIcon sx={{ fontSize: 28 }} />
        </NoticeTitleIcon>
        お客様情報は公開されません。
      </NoticeTitle>
      <NoticeBody>
        不動産会社には「物件情報」のみ公開し、査定を進めます。査定結果を確認後、話を聞きたい不動産会社がいらっしゃいましたらコンシェルジュがお繋ぎします。
      </NoticeBody>
    </Notice>
  );
}
